var React = require('react');

function CloseX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.88344 8.00051L15.8165 1.06746C16.0606 0.823369 16.0606 0.42762 15.8165 0.183558C15.5724 -0.0605038 15.1766 -0.060535 14.9326 0.183558L7.9995 7.11661L1.06649 0.183558C0.822393 -0.060535 0.426644 -0.060535 0.182582 0.183558C-0.0614804 0.427651 -0.0615116 0.823401 0.182582 1.06746L7.1156 8.00048L0.182582 14.9335C-0.0615116 15.1776 -0.0615116 15.5734 0.182582 15.8174C0.304613 15.9395 0.464581 16.0005 0.62455 16.0005C0.784518 16.0005 0.944455 15.9395 1.06652 15.8174L7.9995 8.88442L14.9325 15.8174C15.0546 15.9395 15.2145 16.0005 15.3745 16.0005C15.5345 16.0005 15.6944 15.9395 15.8165 15.8174C16.0606 15.5733 16.0606 15.1776 15.8165 14.9335L8.88344 8.00051Z","fill":"black"}));
}

CloseX.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CloseX;

CloseX.default = CloseX;
